export enum TranslationsTypes {
  BASKET_FIELD = "basket_field",
  CLIENTS_FIELD = "clients_field",
  GATEWAY = "gateway",
  PRODUCT = "product",
  PRODUCTS_CATEGORY = "products_category",
  PRODUCT_RELATED = "product_related",
  PROMOTION = "promotion",
  TAX_TEMPLATE = "tax_template",
  TAX_TAG = "tax_tag",
  TICKET_DEPARTMENT = "ticket_department"
}
